import getAxios from './axiosService'

const searchService = {

  bookSearch (content) {
    return new Promise((resolve, reject) => {
      const axios = getAxios()
      axios.get(`/api/book/search?content=${content}`)
        .then(res => {
          const resData = res.data
          if (resData.result) {
            resolve(resData)
          } else {
            console.error('Get search page with error', resData)
            reject(resData)
          }
        })
    })
  }
}

export default searchService
